<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <tms-form-box
        list-url="/cx-pulse-360"
        :id="id"
        tms-type="tms"
        :form-type="formType"
        @edit="onEdit"
        :loading="loading"
      >
      </tms-form-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import TmsFormBox from '../../components/TmsFormBox.vue';

export default {
  name: 'TMSForm',
  components: {
    TmsFormBox
  },
  async mounted() {
    if (this.$route.name === 'tms-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'tms',
        id: this.id,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New CX Pulse 360' : 'Update CX Pulse 360';
    },
    ...mapState('tms', ['loading', 'tms'])
  },
  methods: {
    ...mapActions('tms', ['getOne', 'postOne', 'patchOne']),
    onEdit({ tms }) {
      this.patchOne({
        type: 'cx-pulse-360',
        id: this.tms.ticketNumber,
        tms,
        router,
        redirectUrl: '/cx-pulse-360'
      });
    }
  }
};
</script>
